module.exports = __webpack_public_path__ + "img/ssl-cancel-anytime.2e1f6c79.jpg";